// extracted by mini-css-extract-plugin
module.exports = {"container":"container--aYuAIlSc","title":"title--Mm3UoueC","details":"details--SPsZUUel"};